import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { actions } from 'store';
import { ModalButtonWithForm } from 'components/common';
import { FormState } from 'components/common/form';
import { MergedCompetency } from 'lib/competencies/getMergedCompetencies';

import type { CompetencyUserEndorsement } from 'shared-types';
import ProfileCompetenciesEndorsementsForm from './ProfileCompetenciesEndorsementsForm';

interface Props {
  competency: MergedCompetency;
  endorsement: Pick<CompetencyUserEndorsement, 'id' | 'comment'>;
  updateCompetencies: () => Promise<void>;
}

const ProfileCompetenciesEndorsementsEdit = ({
  competency,
  endorsement,
  updateCompetencies
}: Props) => {
  const { dispatch } = useDispatch();
  const { messages, theme } = useReduxState();

  const handleSubmit = async (values: FormState) => {
    try {
      const modifiedEndorsement = {
        ...values
      };
      await api.put(
        `/admin/competency-endorsements/${endorsement.id}`,
        modifiedEndorsement
      );
      dispatch(
        actions.addNotice({
          text: messages.competenciesEndorsementEditSuccess,
          type: 'success'
        })
      );
      await updateCompetencies();
    } catch (err) {
      await dispatch.handleErrorDispatch(err);
    }
  };

  return (
    <div>
      <ModalButtonWithForm
        buttonCategory="success"
        buttonIcon="pen"
        buttonSize={'header'}
        buttonText={messages.competenciesEndorsementEdit}
        formAllowEmptyStrings={true}
        modalActionText={messages.commonSave}
        modalTitle={messages.competenciesEndorsementEdit}
        modalWidth="medium"
        onSubmit={handleSubmit}
      >
        {() => (
          <ProfileCompetenciesEndorsementsForm
            commentInitialValue={endorsement.comment}
            competency={competency}
          />
        )}
      </ModalButtonWithForm>
      <style jsx>{`
        .description {
          margin-top: 5px;
          margin-bottom: 15px;
          color: ${theme.textColorLighter};
        }
        .title {
          font-size: 1.6rem;
        }
      `}</style>
    </div>
  );
};

export default ProfileCompetenciesEndorsementsEdit;
